import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { keepStaleInMinutes } from '../../common/queryClient/utils';
import { UserUrl } from './UserUrl';
import { Role } from '../types';

const getUserRoles = () =>
  apiClient.get<Role[]>(UserUrl.ROLE).then((response) => response.data);

export const useUserRolesQuery = createApiQueryHook(
  ['user-roles'],
  getUserRoles,
  keepStaleInMinutes(5)
);
